<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon v-else>fad fa-file-import</v-icon>
      <v-toolbar-title class="ml-0 pl-3">Bank Imports</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container fluid class="pa-0 calc-height grey lighten-2">
        <v-row class="calc-height" dense>
          <v-col cols="3" class="overflow-y-hidden" style="height: 100%">
            <v-card style="height: 100%" class="overflow-y-auto" flat>
              <v-list two-line subheader style="height: 100%">
                <v-list-item-group v-model="selected">
                  <template v-for="(bankImports, day) in groupedImports">
                    <v-subheader :key="day">{{ day }}</v-subheader>
                    <BankImportRow v-for="bankImport in bankImports" :bankImport="bankImport" :key="bankImport.id" />
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col class="overflow-y-hidden" style="height: 100%">
            <v-card style="height: 100%" class="overflow-y-auto" flat>
              <BankImportFile
                v-if="SelectedImport"
                :referral-details.sync="referralDetails"
                :show-referral-create.sync="showReferralCreate"
              ></BankImportFile>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <ReferralEditDialog :show.sync="showReferralCreate" :referral-details="referralDetails" :manual-import="true" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { groupBy } from 'lodash';
import moment from 'moment';
import BankImportRow from '@/components/Platform/BankImports/BankImportRow';
import BankImportFile from '@/components/Platform/BankImports/BankImportFile';
import ReferralEditDialog from '@/components/Platform/Referrals/Widgets/ReferralEditDialog';

export default {
  name: 'BankImports',
  components: { ReferralEditDialog, BankImportFile, BankImportRow },
  data: () => ({
    selected: null,
    showReferralCreate: false,
    referralDetails: null
  }),
  computed: {
    ...mapGetters(['BankImports', 'SelectedImport']),
    groupedImports() {
      return groupBy(this.BankImports, bankImport =>
        moment(bankImport.created_at).calendar(null, {
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          lastDay: '[Yesterday]',
          lastWeek: 'dddd',
          sameElse: 'DD/MM/YYYY'
        })
      );
    }
  },
  methods: {
    ...mapActions(['getBankImports']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  mounted() {
    this.getBankImports();
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  &.filtered {
    height: calc(100vh - 180px);
    max-height: calc(100vh - 180px);
  }
}
</style>
